import * as React from "react";
import { MessageBar, MessageBarType } from "@fluentui/react";

interface WarningBannerProps {
    message: string;
}

const WarningBanner: React.FC<WarningBannerProps> = ({ message }) => {
    const [isVisible, setIsVisible] = React.useState(true);

    if (!isVisible) return null;

    return (
        <MessageBar
            messageBarType={MessageBarType.warning}
            onDismiss={() => setIsVisible(false)}
            dismissButtonAriaLabel="Close"
        >
            {message}
        </MessageBar>
    );
};

export default WarningBanner;
